import { render, staticRenderFns } from "./videoMonitor.vue?vue&type=template&id=0672c47e&"
import script from "./videoMonitor.vue?vue&type=script&lang=js&"
export * from "./videoMonitor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports